import React from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import "./ProgramGrid.css";

const ProgramGrid = () => {
  const programs = useSelector(
    (state) => state.contentfulReducer.programTitles
  );

  const scrollToTop = () => window.scrollTo(0, 0);

  return (
    <section
      id="programs"
      className="home-section home-section--alt"
      aria-labelledby="programs-heading"
    >
      <div className="home-section__inner">
        <header className="home-section__header">
          <h2 id="programs-heading" className="home-section__title">
            Our Programs
          </h2>
          <p className="home-section__subtitle">
            From first steps to competitive excellence — find the right path for
            your athlete.
          </p>
        </header>
        <div className="home-program-grid">
          {programs.map((program) => {
            const fields = program.fields;
            const imageUrl = fields.image?.fields?.file?.url;
            const path = `/programs/program-details/${fields.displayName}`;

            return (
              <article key={fields.displayName} className="home-program-card">
                <Link
                  to={path}
                  onClick={scrollToTop}
                  className="home-program-card__link"
                  data-track="program_click"
                  data-track-location="home_program_grid"
                  data-track-item={fields.displayName}
                >
                  {imageUrl && (
                    <div className="home-program-card__image-wrap">
                      <img
                        src={imageUrl}
                        alt={`${fields.name || fields.displayName} gymnastics program at Ace Gymnastics`}
                        width="400"
                        height="300"
                        loading="lazy"
                      />
                    </div>
                  )}
                  <div className="home-program-card__body">
                    <h3 className="home-program-card__title">
                      {fields.name || fields.displayName}
                    </h3>
                    {fields.description && (
                      <p className="home-program-card__desc">
                        {fields.description.length > 120
                          ? `${fields.description.slice(0, 120).trim()}…`
                          : fields.description}
                      </p>
                    )}
                    <span className="home-program-card__cta">Learn more →</span>
                  </div>
                </Link>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ProgramGrid;
